import { authorized, } from '@/auth';

let refreshInterval = null;
export default {
	data() {
		return {
			isAuth: false,
			refreshInterval: null
		}
	},
	created() {
		this.isAuth = authorized()
/*
		if (this.isAuth && refreshInterval === null) {
			refreshInterval = setInterval(async function () {
				await refresh();
			}, 60000);
		}*/
	},
	beforeDestroy () {
		clearInterval(refreshInterval)
	},
}